import React, { useState , useEffect} from "react"
import { navigate } from 'gatsby'
import PropTypes from "prop-types"
import MobileHeader from './mobile-header'
import MobileFooter from './MobileFooter/mobile_footer'
import "./layout.scss"
import '../styles/icons.scss'

const isBrowser = () => typeof window !== "undefined"

const MobileLayout = ({ children }) => {

  const [activeButton, setActiveButton] = useState('')

  useEffect(() => {
    var pages_array = ['my-trainings,videos,lptv,blogs,events,my-quizzes,resources,web-recordings,my-speak-series,prime-content,trainers-calendar','classroom,onlinecourses,eLearning,quizzes,openassessment','our-team, leanpitch-reviews, why-us, ourtrainers, our-presence, cities, about-us, about,update-profile']
    let page_uri = isBrowser() ? '/'+window.location.pathname.substr(1) :  'false'
    let page_location = isBrowser() ? window.location :  'false'
    if (page_uri.split("/")[1] === 'onlinecrashcourses') {
      setActiveButton( 'onlinecourses' )
    }
    if (page_location.hash.split("/")[0] === "#all-trainings") {
      setActiveButton('')
    }else if (page_uri.replace(/\//g, "") === "") {
      setActiveButton('')
    }else if (page_uri.replace(/\//g, "") === 'dashboard') {
      setActiveButton('')
    }else if (page_uri.replace(/\//g, "") === 'insitute-of-product-leadership') {
      navigate('/#all-trainings', { replace: true })
    }else {
      for (var i = 0; i <= pages_array.length - 1; i++) {
        if ( pages_array[i].includes( page_uri.split("/")[1] ) ) {
          setActiveButton( page_uri.split("/")[1] )
          if (page_uri.split("/")[1] === 'cities') {
            setActiveButton( 'our-presence' )
          } else if (page_uri.split("/")[1] === 'trainer' || page_uri.split("/")[1] === 'ourtrainers') {
            setActiveButton( 'ourtrainers' )
          } else if (page_uri.split("/")[1] === 'about' || page_uri.split("/")[1] === 'about-us') {
            setActiveButton( 'our-team' )
          } else if (page_uri.split("/")[1] === 'openassessment') {
            setActiveButton( 'quizzes' )
          }else if (page_uri.split("/")[1] === 'lptv') {
            setActiveButton( 'videos' )
          }
        }
      }
    }
  },[isBrowser() ? window.location : ''])


  return(
    <React.Fragment>
      <MobileHeader />
      <div id="child-layout" style={{width: '100%', minWidth: '100%', maxWidth: '100%', marginTop:'48px', marginBottom:'48px'}} className={`child-layout ml-0 float-left`}>
        {children}
      </div>
      <MobileFooter active_button={activeButton} />
    </React.Fragment>
  )
}

MobileLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default MobileLayout
